import { AB_PLATFORM_SSR, AB_PLATFORM_IGNORE } from '@src/config/constants'
import { getAssignedExperimentBuckets } from '@src/experiments'
import { AssignedExperimentBucket } from '@src/experiments/experiments.types'
import { statsigExperimentManager } from '@src/experiments/statsig-integration'
import AuthUtil from '@src/quince-site-common/src/utils/authUtil'
import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

const getIsPlatformSSR = (): string[] => {
  if (!isBrowser()) return []

  try {
    const platformCookie = getCookie(ANALYTIC_COOKIES.PLATFORM_AB)
    // eslint-disable-next-line i18next/no-literal-string
    if (platformCookie?.includes('ssr')) return [AB_PLATFORM_SSR]
    // eslint-disable-next-line i18next/no-literal-string
    if (platformCookie?.includes('ignore')) return [AB_PLATFORM_IGNORE]
  } catch (error) {
    // Handle cookie service errors gracefully
    return []
  }

  return []
}

const shouldTrackBucketForUser = (experiment: AssignedExperimentBucket): boolean => {
  try {
    const loggedInUser = experiment.loggedInUsersOnly && AuthUtil.isLoggedIn()
    const loggedInCondition = !experiment.loggedInUsersOnly || loggedInUser
    return loggedInCondition
  } catch (error) {
    // If auth service is unavailable, filter out logged-in only experiments
    return !experiment.loggedInUsersOnly
  }
}

const getAssignedExperimentBucketsForLogging = () => {
  try {
    const assignedExperimentBuckets = getAssignedExperimentBuckets()

    // Handle null/undefined return values
    if (!assignedExperimentBuckets) {
      return []
    }

    const experimentsToTrack = Object.values(assignedExperimentBuckets)
      .filter(shouldTrackBucketForUser)
      .filter(experiment => experiment.isActive)
    const assignedExpLogs = experimentsToTrack.map(experiment => ({
      experimentName: experiment.name,
      bucketName: experiment.bucket,
    }))

    return assignedExpLogs
  } catch (error) {
    // Handle any errors in getting assigned experiment buckets
    return []
  }
}

export const getActiveExperiments = () => {
  const activeExperiments = []

  try {
    const experimentBuckets = [
      ...getAssignedExperimentBucketsForLogging(),
      ...statsigExperimentManager.getActiveExposedBuckets(),
    ]
    for (const experimentBucket of experimentBuckets) {
      activeExperiments.push(`${experimentBucket.experimentName}_${experimentBucket.bucketName}`)
    }
  } catch (error) {
    // Handle any errors in getting experiment buckets
    // Return only platform and page experiments if there's an error
  }

  return [...activeExperiments, ...getIsPlatformSSR()]
}
